import React, { useState, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

import ServiceForm from './serviceForm';
import ServiceList from './serviceList';

import { getPathVariables } from '../../misc';
import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../contentful';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

const AdditionalServices = ({
  additionalServices,
  setAdditionalServices,
  setIsFormTouched
}) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    callCentre: { labelAdditionalServices }
  } = localizedStrings;

  const [servicesList, setServicesList] = useState([]);
  const [editService, setEditService] = useState();
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'additionalServices',
    locale
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      const list = getData(res).serviceList.map(service => {
        return service.fields;
      });
      setServicesList(list);
    });
  }, []);

  return (
    <>
      <div style={{ margin: '1rem 0' }}>
        <Typography heading="h2" variant={{ size: 'h2' }} block>
          {labelAdditionalServices}
        </Typography>
      </div>
      <ServiceForm
        additionalServices={additionalServices}
        setAdditionalServices={setAdditionalServices}
        servicesList={servicesList}
        editService={editService}
        setEditService={setEditService}
        setIsFormTouched={setIsFormTouched}
      />
      {((!editService && additionalServices.length > 0) ||
        (editService && additionalServices.length > 1)) && (
        <ServiceList
          additionalServices={additionalServices}
          setAdditionalServices={setAdditionalServices}
          setEditService={setEditService}
          setIsFormTouched={setIsFormTouched}
          editService={editService}
        />
      )}
    </>
  );
};

AdditionalServices.propTypes = {
  additionalServices: PropTypes.arrayOf(PropTypes.any).isRequired,
  setAdditionalServices: PropTypes.func.isRequired,
  setIsFormTouched: PropTypes.func.isRequired
};

export default AdditionalServices;
